import { ResourceTypeLiteral } from '@sharefiledev/fileviewer-pilet-sdk';
import { RID } from '@sharefiledev/sfplugin-resource-id';

export function getContainerRID(rid: string) {
	const segment = RID.parse(rid);
	if (!segment) {
		return undefined;
	}
	if (segment.entityType === ResourceTypeLiteral.FileVersion) {
		return segment.parent()?.parent()?.toString();
	}
	return segment.parent()?.toString();
}

export function isResourceFileType(type: string): boolean {
	return ResourceTypeLiteral.File === type || ResourceTypeLiteral.FileVersion === type;
}

export function isResourcesOfSameType(
	resourceRids: string[],
	requiredResourceType: string
): boolean {
	if (!resourceRids || resourceRids.length === 0) {
		return false;
	}

	for (const rid of resourceRids) {
		const segment = RID.parse(rid);
		if (segment.entityType !== requiredResourceType) {
			return false;
		}
	}

	return true;
}
